import { Validators } from '@angular/forms';

/* istanbul ignore next */
export function calculateComponentsTotal(
  components: any[],
  componentControls: any[]
): number {
  return components.reduce((total, item, index) => {
    const control = componentControls.at(index);
    const useCustomPrice = control.get('useCustomPrice')?.value;
    const customPrice = parseFloat(control.get('customPrice')?.value ?? '0');

    const unitPrice = useCustomPrice
      ? customPrice
      : parseFloat(item.component.prices?.[0]?.unitPrice ?? '0');

    const quantity = item.quantity ?? 1; // ensure quantity exists
    return total + unitPrice * quantity;
  }, 0);
}

export interface InviteFailure {
  email: string;
  message: string;
}

/* istanbul ignore next */
export function parseInviteErrors(errors: string): InviteFailure[] {
  return errors.split(',').map((entry) => {
    const trimmed = entry.trim();
    const separatorIndex = trimmed.indexOf(':');
    if (separatorIndex === -1) {
      return { email: trimmed, message: trimmed };
    }
    return {
      email: trimmed.slice(0, separatorIndex).trim(),
      message: trimmed.slice(separatorIndex + 1).trim(),
    };
  });
}

export interface InviteFailureState {
  failedEmails: string[];
  failedEmailMessages: string[];
  inviteErrorMessage: string;
}

/* istanbul ignore next */
export function buildInviteFailureState(rawErrors: string): InviteFailureState {
  const failures = parseInviteErrors(rawErrors);
  return {
    failedEmails: failures.map((failure) => failure.email),
    failedEmailMessages: failures.map(
      (failure) => `${failure.email}: ${failure.message}`
    ),
    inviteErrorMessage:
      failures.length === 1 ? failures[0].message : rawErrors,
  };
}

/* istanbul ignore next */
export function isConnectComponent(
  componentControl: any,
  connectComponentIds: number[]
): boolean {
  const componentId = componentControl?.get('component')?.value?.id;
  if (componentId == null) return false;
  return connectComponentIds.includes(Number(componentId));
}

/* istanbul ignore next */
export function applyConnectFieldValidators(
  componentControl: any,
  connectComponentIds: number[]
): void {
  const isConnect = isConnectComponent(componentControl, connectComponentIds);
  ['numberOfUnits', 'numberOfPerimeterAmenity'].forEach((name) => {
    const control = componentControl.get(name);
    if (!control) return;
    if (isConnect) {
      control.setValidators([Validators.required, Validators.min(0)]);
    } else {
      control.clearValidators();
      control.setValue(null);
    }
    control.updateValueAndValidity();
  });
}

/* istanbul ignore next */
export function getConnectComponentControl(
  components: any,
  connectComponentIds: number[]
): any {
  return components.controls.find((control: any) =>
    isConnectComponent(control, connectComponentIds)
  );
}
